import React from "react";

// Carte centrée utilisée par les pages de connexion, d'inscription et de
// réinitialisation de mot de passe.
export default function AuthLayout({ title, subtitle, children, footer }) {
    return (
        <div className="lk-auth">
            <div className="lk-auth__card">
                <div className="lk-auth__brand">
                    <img src="/logo-full.png" alt="Lokapp" />
                </div>
                <h1 className="lk-auth__title">{title}</h1>
                {subtitle && <p className="lk-auth__subtitle">{subtitle}</p>}
                {children}
            </div>
            {footer && <p className="lk-auth__footer">{footer}</p>}
        </div>
    );
}

// Champ de formulaire : libellé au-dessus, aide/erreur en dessous.
export function AuthField({ id, label, action, error, help, children }) {
    return (
        <div className="lk-field">
            <label className="lk-field__label" htmlFor={id}>
                <span>{label}</span>
                {action}
            </label>
            {children}
            {error ? <small className="lk-field__error">{error}</small> : help ? <small className="lk-field__help">{help}</small> : null}
        </div>
    );
}
